import { createAsyncThunk } from "@reduxjs/toolkit";

import { axiosInstance as axios } from "../../../../api/axiosInstance";

export const getOperatorUserInfo = createAsyncThunk(
  "getOperatorUserInfo",
  async(operatorId: string | undefined, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    return axios.get(`/api/v1/operators/${operatorId}`)
      .then(resp => resp.data)
      .catch(() => {
        const errorMessage = `There was an error getting the information for Operator ${operatorId}`;

        return rejectWithValue(errorMessage);
      });
  }
);
